// The five kinds of Data Tools content an administrator manages (IB-1802, DT-003-3).
//
// Defined once and shared by the sidebar, the routes and the management shell, so a section can
// never appear in one place and be missing from another. `itemType` matches the DataToolsItemType
// enum on the server, and is what the eventual CRUD screens filter on.

export type DataToolsSection = {
  slug: string;
  title: string;
  itemType: 'ASSET' | 'TEMPLATE' | 'BLUEPRINT' | 'RULE_SET' | 'REFERENCE_DATASET';
  description: string;
};

export const DATA_TOOLS_SECTIONS: DataToolsSection[] = [
  {
    slug: 'assets',
    title: 'Data Assets',
    itemType: 'ASSET',
    description: 'Reference data and downloads offered in the public Data Assets library.',
  },
  {
    slug: 'templates',
    title: 'Preparation Templates',
    itemType: 'TEMPLATE',
    description: 'Spreadsheet templates people download before preparing their own data.',
  },
  {
    slug: 'blueprints',
    title: 'Flatfile Blueprints',
    itemType: 'BLUEPRINT',
    description: 'Field definitions that drive column mapping and validation on upload.',
  },
  {
    slug: 'rule-sets',
    title: 'Validation Rule Sets',
    itemType: 'RULE_SET',
    description: 'Cleaning and validation rules applied to an uploaded file.',
  },
  {
    slug: 'reference-datasets',
    title: 'Reference Datasets',
    itemType: 'REFERENCE_DATASET',
    description: 'Master lists uploaded data is matched against, such as geography and schools.',
  },
];

export const DATA_TOOLS_BASE_PATH = '/admin/data-tools';

export const getDataToolsSection = (slug?: string): DataToolsSection | undefined =>
  DATA_TOOLS_SECTIONS.find(section => section.slug === slug);

// Mirrors the DataToolsAccess enum. The labels say what a visitor experiences rather than naming
// the enum value, because that is the decision an administrator is actually making.
export const ACCESS_OPTIONS = [
  { value: 'PUBLIC_PREVIEW', label: 'Public preview' },
  { value: 'CONTACT_GATED', label: 'Contact form required' },
  { value: 'AUTHENTICATED', label: 'Signed-in users only' },
  { value: 'FREE_PLAN_STARTER', label: 'Free plan starter' },
  { value: 'PAID_ONLY', label: 'Paid plans only' },
];

// Mirrors the DataToolsDataset enum.
export const DATASET_OPTIONS = [
  { value: 'PEOPLE', label: 'People and Beneficiaries' },
  { value: 'INSTITUTIONS', label: 'Institutions and Sites' },
  { value: 'INDICATORS', label: 'Indicators and Results' },
];

export const STATUS_LABELS: { [status: string]: string } = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  UNPUBLISHED: 'Unpublished',
  RETIRED: 'Retired',
};
